/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  setTimeout(() => {
    document.querySelector('#NavStandard').style.opacity = '1';
  }, 1500);

  
  const discountSettings = window.siteDiscountSettings;
  if (!discountSettings?.enabled || !discountSettings?.percentage) return;

  subscribe(theme.PUB_SUB_EVENTS.variantChange, function(event) {
    const variant = event.data.variant;
    console.log(variant);
    if (!variant) return;

    const percentageAmount = discountSettings.percentage;
    const regularPrice = variant.price;
    const discountAmount = Math.floor(regularPrice * percentageAmount / 100);
    const finalPrice = regularPrice - discountAmount;

    const formattedFinalPrice = window.theme.formatMoney(finalPrice, theme.moneyFormat);
    const formattedRegularPrice = window.theme.formatMoney(regularPrice, theme.moneyFormat);

    const priceBox = document.querySelector('.product-card-discount-price-box');
    if (!priceBox) return;

    const finalPriceEl = priceBox.querySelector('[data-product-price]');
    const comparePriceEl = priceBox.querySelector('[data-compare-price]');

    if (finalPriceEl) finalPriceEl.innerHTML = formattedFinalPrice;
    if (comparePriceEl) comparePriceEl.innerHTML = formattedRegularPrice;
  });






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
